<script setup lang="ts">

import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'

/**
 * Props
 */
const props = defineProps<{
  shipActionData: {
    action: string;
    targetX: number;
    targetY: number;
    targetPlayer: number;
    targetShip: number;
    duration?: number;
    daysRemaining?: number;
    data: {
      name: string;
      type: number;
      typeVariantId: number;
      targetPlayer: number;
    }
  },
  eta: number
}>();

// Computed property for wait duration display (uses daysRemaining from backend)
const waitDurationDisplay = computed(() => {
  if (props.shipActionData.daysRemaining !== undefined && props.shipActionData.daysRemaining > 0) {
    return `${props.shipActionData.daysRemaining}`
  }
  if (props.shipActionData.duration !== undefined && props.shipActionData.duration > 0) {
    return `${props.shipActionData.duration}`
  }
  return "0"
})

// Computed property for wait status text
const waitStatusText = computed(() => {
  const days = props.shipActionData.daysRemaining ?? props.shipActionData.duration
  if (days !== undefined && days > 0) {
    return `Waiting for ${days} day${days === 1 ? '' : 's'}`
  }
  return "Wait complete"
})

</script>

<template>
  <StandardCard top-padding="0" bottom-padding="1">
    <div class="flex justify-between text-subtext w-full">
      <div class="flex gap-4">
        <GenericIcon tooltip="Wait" type="zzz" class="hidden md:inline"/>
        <div>
          {{ waitStatusText }}
        </div>
      </div>
      <div class="flex-shrink-0 ps-2">
        {{ waitDurationDisplay }} days
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>